
<template lang="pug">
  .eui-typeaheadSearch(:class="{ 'eui-typeaheadSearch_active': showResults }")
    .eui-typeaheadSearch_results(v-if="showResults")
      .eui-typeaheadSearch_results_item(v-for="result in results", @click="handleItemClick(result)")
        span {{ result.name }}

    SearchInput( @inputChange="updateSearchValue", @focusChange="handleFocusChange")
</template>


<script>

import SearchInput from '../SearchInput/SearchInput.vue';

export default {
  name: 'eui-typeaheadSearch',
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      searchValue: null,
      focused: false
    };
  },
  computed: {
    results() {
      return this.searchValue?.length > 1 ? this.items.filter( item => {
        return item?.name?.toLowerCase()?.match(this.searchValue?.toLowerCase());
      }) : [];
    },
    showResults() {
      return this.results.length && this.focused;
    }
  },
  methods: {
    updateSearchValue(val) {
      console.log('updateSearchValue', val);
      this.searchValue = val;
    },
    handleItemClick(result) {
      console.log('handleItemClick', result.id);
      this.$emit('searchSelection', `${ result.id }`);
    },
    handleFocusChange(value) {

      setTimeout( () => {
        this.focused = value;
        console.log('handleFocusChange', value);
      }, 200 );
    }
  },
  components: {
    SearchInput
  }
};

</script>

<style lang="scss">
.eui-typeaheadSearch {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  z-index: 1;
  margin-bottom: var(--spacing-unit);

  &_active {
    + .eui-accordian {
      opacity: 0.2;
      pointer-events: none;
    }
  }

  &_results {
    position: relative;
    width: 100%;
    display: inline-flex;
    flex-direction: column;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;

    border: 2px solid var(--background-lightgrey);
    border-radius: var(--spacing-unit);
    padding-top: var(--spacing-unit-x3);
    margin-top: calc(var(--spacing-unit-x3) * -1);
    background: var(--background-offwhite);

    &_item {
      border-top: 1px solid var(--background-lightgrey);
      padding:  var(--spacing-unit) var(--spacing-unit-x2);
      cursor: pointer;

      &:hover {
        background: var(--highlight-color);
        color: #fff;
      }

      &:first-child {
        border-top: 0;
      }
    }
  }
}

</style>
